export default {"src":"/_next/static/media/celebration.6fff8cae.svg","height":48,"width":52,"blurWidth":0,"blurHeight":0};